import { ContainerFooter } from "./styles";
import { BsTwitter } from 'react-icons/bs'
import { SiDiscord } from 'react-icons/si'
import { SiTiktok } from 'react-icons/si'

export function Footer() {
    return(
        <ContainerFooter>
            <ul>
                <li className="icons">
                    <a href="https://bit.ly/3M0ik7A" target="_blank" rel="noreferrer"> 
                        <BsTwitter />
                    </a>
                </li>
                <li className="icons">
                    <a href="http://bit.ly/3KI0Nkh" target="_blank" rel="noreferrer"> 
                        <SiDiscord />
                    </a>
                </li>
                <li>
                    <a href="https://bit.ly/3uG9hTG" target="_blank" rel="noreferrer">
                        <SiTiktok />
                    </a>
                </li>
            </ul>
            <div className="copyright">
            © 2022. All Rights Reserved.
            </div>
        </ContainerFooter>
    )
}